import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import type { TimeSlot } from 'features/GuestReschedule/types';
import { AvailableTimeItem } from './AvailableTimeItem';

interface AvailableTimeListProps {
  readonly date: string;
  readonly slots: TimeSlot[];
  readonly selectedSlotId: string | null;
  readonly onSelectSlot: (value: string) => void;
}

export const AvailableTimeList: React.FC<AvailableTimeListProps> = ({
  date,
  slots,
  selectedSlotId,
  onSelectSlot,
}) => {
  const { t } = useTranslation();

  return (
    <DayRow>
      <DateColumn>{format(parseISO(date), 'MMMM do')}</DateColumn>
      <SlotsWrap>
        {slots.length > 0 ? (
          slots.map((slot) => (
            <AvailableTimeItem
              key={slot.value}
              name={date}
              value={slot.value}
              label={`${slot.startTime} - ${slot.endTime}`}
              selected={selectedSlotId === slot.value}
              onChange={() => onSelectSlot(slot.value)}
            />
          ))
        ) : (
          <NoSlots>{t('noTimesAvailable')}</NoSlots>
        )}
      </SlotsWrap>
    </DayRow>
  );
};

const DayRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 32px;
`;

const DateColumn = styled.div`
  min-width: 100px;
  font-size: 14px;
  padding-top: 10px;
  font-weight: 500;
`;

const SlotsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 14px;
`;

const NoSlots = styled.span`
  color: #666;
  font-size: 14px;
  padding-top: 10px;
  font-weight: 500;
`;
